module.exports = __webpack_public_path__ + "img/right_2.6412bfbe.jpg";